import type { StorefrontNetworkAndPvRecCategory } from '@api/storefrontsNetworkPvRec';

/** @internal */
export const countByCategory = (
	network: StorefrontNetworkAndPvRecCategory[],
	field: 'pvRec' | 'storefrontNetwork',
): Record<string, number> => {
	const counts: Record<string, number> = {};
	for (const item of network) {
		const count = item[field].length;
		if (count > 0) {
			counts[item.categoryCode] = count;
		}
	}
	return counts;
};

/** @internal */
export const formatCategoryCounts = (counts: Record<string, number>): string =>
	Object.entries(counts)
		.map(([category, count]) => `${category}: ${count}`)
		.join(', ');

export const calculateCategoryCounts = (
	network: StorefrontNetworkAndPvRecCategory[],
) => {
	const pvRecCounts = countByCategory(network, 'pvRec');
	const storefrontNetworkCounts = countByCategory(network, 'storefrontNetwork');

	const vendorNetworkRecCountTotal = network.reduce(
		(total, cat) => total + cat.pvRec.length + cat.storefrontNetwork.length,
		0,
	);

	return {
		recommendationCount: formatCategoryCounts(pvRecCounts),
		vendorNetworkRecCount: formatCategoryCounts(storefrontNetworkCounts),
		vendorNetworkRecCountTotal,
	};
};
